import "./App.css";
import { Grid, ThemeProvider } from "@mui/material";
import mainTheme from "./theme.tsx";
import CssBaseline from "@mui/material/CssBaseline";
import { useDispatch } from "react-redux";
import { useEffect, useLayoutEffect, useState } from "react";
import {
  conversationActions,
  fetchConversations,
} from "./store/conversation.tsx";
import { login } from "./store/auth.tsx";
import { fetchExamples } from "./store/clickedExample.tsx";
import EconomicConnect from "./components/integration/EconomicConnect.tsx";
import ConversationContainer from "./components/conversation/ConversationContainer.tsx";
import { useTypedSelector } from "./hooks.tsx";
import handleSignupToken from "./components/search/signup/handleSignupToken.tsx";
import { loadCatalog } from "./i18n.ts";

let isInitial: boolean = true;

function App() {
  useLayoutEffect(() => {
    if (navigator.language === "da") {
      loadCatalog("da");
    } else {
      loadCatalog("en");
    }
  }, []);

  const [loading, setLoading] = useState(true);
  const isAuthenticated = useTypedSelector(
    (state) => state.authState.isLoggedIn,
  );
  const loginToken = useTypedSelector((state) => state.authState.loginToken);
  const dispatch = useDispatch();

  useEffect(() => {
    const updateLoginToken = () => {
      let token_from_storage = localStorage.getItem("token");
      if (token_from_storage === null || token_from_storage === "") {
        if (isInitial) {
          dispatch(fetchExamples({ isLoggedIn: false }) as any);
          isInitial = false;
        }
        setLoading(false);
        return false;
      }
      let setToken = !loginToken && token_from_storage;
      if (setToken) {
        dispatch(login(token_from_storage));
      }
      setLoading(false);
      return setToken;
    };

    const fetchExchangesOnLogin = () => {
      if (!isInitial || !isAuthenticated) {
        return;
      }
      isInitial = false;
      dispatch(fetchConversations() as any);
      dispatch(fetchExamples({ isLoggedIn: true }) as any);
      dispatch(conversationActions.setSelectedConversation("new"));
    };

    let setToken = updateLoginToken();
    if (!setToken) {
      fetchExchangesOnLogin();
    }
  }, [loginToken, dispatch, isAuthenticated]);

  const [route, _] = useState(window.location.pathname);

  const signUpToken = useTypedSelector(
    (state) => state.authState.anonymousSession?.signUpState?.signUpToken,
  );
  useEffect(() => {
    const signupToken = async () => {
      await handleSignupToken(signUpToken, dispatch);
    };

    signupToken();
  }, [signUpToken, dispatch]);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === "/integration/e-conomic/connect") {
      const urlParams = new URLSearchParams(window.location.search);
      const economicToken = urlParams.get("token");
      if (economicToken) {
        localStorage["economicToken"] = economicToken;
      }
    }
  }, []);

  if (loading) {
    return <div>Loading...</div>; // or a spinner/loading component
  }

  if (route === "/integration/e-conomic/connect") {
    return (
      <ThemeProvider theme={mainTheme}>
        <CssBaseline />
        <EconomicConnect />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={mainTheme}>
      <CssBaseline />
      <Grid container direction="row" spacing={3} alignContent="center">
        <ConversationContainer />
      </Grid>
    </ThemeProvider>
  );
}

export default App;
